export default "__VITE_ASSET__CRw2wpMg__"